import AdminSidebar from '../components/admin/AdminSidebar';
import AdminHeader from '../components/admin/AdminHeader';
import AdminServicesComponent from '../components/admin/AdminServices';

export default function AdminServices() {
  return (
    <div className="flex min-h-screen bg-gradient-to-br from-gray-900 via-gray-800 to-gray-900">
      <AdminSidebar />
      <div className="flex-1 ml-0 ">
        <AdminHeader 
          title="Gestion des Services" 
          subtitle="Créez et gérez vos services ici"
        />
        <div className="p-6">
          <AdminServicesComponent />
        </div>
      </div>
    </div>
  );
}